import React from 'react';

import type { BadgeRootProps } from '@rtkwlf/fenrir-react';
import { Badge } from '@rtkwlf/fenrir-react';

type BadgeAppearance = BadgeRootProps['appearance'];

export const StatusBadge: React.FC<{ value: string }> = ({ value = '' }) => {
  let appearance: BadgeAppearance;

  switch (value.toLowerCase()) {
    case 'new':
      appearance = 'success';
      break;
    case 'critical':
    case 'failure':
      appearance = 'danger';
      break;
    case 'high':
      appearance = 'warning';
      break;
    case 'medium':
      appearance = 'attention';
      break;
    case 'normal':
    case 'low':
    case 'success':
      appearance = 'info';
      break;
    default:
      appearance = 'default';
  }

  return (
    <Badge.Root appearance={appearance}>
      <Badge.Text textTransform="capitalize">{value}</Badge.Text>
    </Badge.Root>
  );
};
